/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SafeboxRound = {
    /**
     * Round ID
     */
    id?: string;
    /**
     * Current jackpot amount
     */
    jackpot?: number;
    /**
     * Price per attempt
     */
    attemptPrice?: number;
    /**
     * Round status (0=ACTIVE, 1=FINISHED)
     */
    status?: SafeboxRound.status;
    /**
     * User ID of winner (if round is finished)
     */
    winnerUserId?: string | null;
    /**
     * Winning code (if round is finished)
     */
    winningCode?: number | null;
    /**
     * Creation timestamp
     */
    createdAt?: string;
    /**
     * Last update timestamp
     */
    updatedAt?: string;
};
export namespace SafeboxRound {
    /**
     * Round status (0=ACTIVE, 1=FINISHED)
     */
    export enum status {
        '_0' = 0,
        '_1' = 1,
    }
}

